import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { AttachmentTypeGetAsCollection, AttachmentTypeGetAsCollectionResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<AttachmentTypeGetAsCollectionResponse, AttachmentTypeGetAsCollectionResponse>) => {
    return response?.data?.attachmentTypes
}
const getError = (response?: SWRResponse<AttachmentTypeGetAsCollectionResponse, AttachmentTypeGetAsCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const useAttachmentTypes = (configuration?: SWRConfiguration<AttachmentTypeGetAsCollectionResponse, AttachmentTypeGetAsCollectionResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new AttachmentTypeGetAsCollection();
        };
    }, [])

    return useGet(request, { getData, getError }, configuration);
}

export default useAttachmentTypes;